/**
 * 班级
 */
export const CLASS_ITEMS = [
  {
    name: "机械工程及自动化",
    code: "001",
  }, {
    name: "机械电子工程",
    code: "002",
  }, {
    name: "工业工程",
    code: "003",
  }]
/**
 * 教师
 */
export const TEACHER_ITEMS = [
  {
    name: "温馨",
    tno: "001",
  }, {
    name: "张婵",
    tno: "002",
  }, {
    name: "朱康康",
    tno: "003",
  }]

/**
 *  课程图片地址
 */
export const PICTURES = ["http://macro-oss.oss-cn-shenzhen.aliyuncs.com/mall/images/20180607/5ab46a3cN616bdc41.jpg",
  "http://macro-oss.oss-cn-shenzhen.aliyuncs.com/mall/images/20180607/5ac1bf5fN2522b9dc.jpg"]

/**
 *  项目图片地址
 */
export const PICTURES_PROJECT = ["https://qitou.oss-cn-hangzhou.aliyuncs.com/zju/20220325/dbs_L1.png",
  "https://qitou.oss-cn-hangzhou.aliyuncs.com/zju/20220325/area-4.png"]
/**
 * 项目信息列表
 */
export const PROJECT_LIST = [{
  pno: "22",
  name: "机械臂实验",
  teacher: "温馨",
  capacity: 20,
},
{
  pno: "33",
  name: "特洛伊实验",
  teacher: "温馨、张婵",
  capacity: 30,
}, {
  pno: "44",
  name: "仿真实验",
  teacher: "张婵",
  capacity: 40,
}]

/**
 * 发布任务列表
 */
export const TASK_PUBLISH_LIST= [{
  taskNo:"aa",
  cname: "机械设计",
  cno:'88',
  pno:'33',
  snos:'201824111258,201824111244',
  pname: "机械臂实验",
  pteacher: "温馨",
  deadline: '2022-09-01 12:00',
  limitNum:10,
  auditFlag:0,
  choiceStudent:"钟文坚, 姜春景，张三, 李四, 思思",
  relationStudent:"张三, 李四, 思思,五五, 钟文坚, 姜春景，张三, 李四, 思思,五五, 钟文坚, 姜春景，张三, 李四, 思思,五五, 钟文坚, 姜春景",
},
{
  taskNo:"bb",
  cname: "机械设计",
  cno:'88',
  pno:'44',
  snos:'201824111244',  
  pname: "特洛伊实验",
  pteacher: "温馨、张婵",
  deadline: '2022-09-01 12:00',
  limitNum:0,
  auditFlag:0,
  choiceStudent:"",  
  relationStudent:"五五, 钟文坚, 姜春景",
}, {
  taskNo:"cc",
  cname: "机械设计",
  cno:'88',
  pno:'44',
  snos:'201824111244',  
  pname: "特洛伊实验",
  pteacher: "温馨、张婵",
  deadline: '2022-10-01 12:00',
  limitNum:5,
  auditFlag:0,
  choiceStudent:"钟文坚, 姜春景，张三",  
  relationStudent:"钟文坚, 姜春景，张三",
},{
  taskNo:"dd",
  cname: "数据结构",
  cno:'22',
  pno:'',
  snos:'',  
  pname: "仿真实验",
  pteacher: "张婵",
  limitNum:7,
  deadline: '2022-09-01 12:00',
  auditFlag:1,
  choiceStudent:" 姜春景",  
  relationStudent:"姜春景",
},{
  taskNo:"ee",
  cname: "数据结构",
  cno:'22',
  pno:'',
  snos:'',  
  pname: "特洛伊实验",
  pteacher: "张婵",
  limitNum:7,
  deadline: '2022-08-01 12:00',
  auditFlag:0,
  choiceStudent:"",  
  relationStudent:"",
}]


/**
 * 我的课程列表
 */
 export const MY_COURSE_LIST= [{
  taskNo:"aa",
  cname: "机械设计",
  cno:'88',
  pno:'33',
  sno:'201824111258',
  sname:'钟文坚',
  pname: "机械臂实验",
  pteacher: "温馨",
  className: "机械电子工程",
  fileList:[{name: 'food.jpeg', url: 'https://qitou.oss-cn-hangzhou.aliyuncs.com/zju/20220325/dbs_L1.png'}, {name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}],
},{
  taskNo:"bb",
  cname: "机械设计",
  cno:'88',
  pno:'44',
  sno:'201824111244',  
  sname:'姜春景',
  pname: "特洛伊实验",
  pteacher: "温馨、张婵",
  className: "机械电子工程",
  fileList:[{name: 'food2.jpeg', url: 'https://qitou.oss-cn-hangzhou.aliyuncs.com/zju/20220325/dbs_L1.png'}],
}, {
  taskNo:"cc",
  cname: "机械设计",
  cno:'88',
  pno:'44',
  sno:'201824111244',  
  sname:'张三',
  pname: "特洛伊实验",
  pteacher: "温馨、张婵",
  className: "工业工程",
  fileList:[{name: '历史记录.doc', url: 'https://qitou.oss-cn-hangzhou.aliyuncs.com/zju/20220325/dbs_L1.png'}],
}]